"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants_1 = require("../../GameConstants");
var GameVars_1 = require("../../GameVars");
var HUD = /** @class */ (function (_super) {
    __extends(HUD, _super);
    function HUD(game) {
        var _this = _super.call(this, game, null, "hud") || this;
        _this.tempScore = 0;
        // top
        var topContainer = new Phaser.Group(_this.game);
        topContainer.scale.y = GameVars_1.GameVars.scaleY;
        _this.add(topContainer);
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            _this.fpsLabel = new Phaser.Text(_this.game, GameConstants_1.GameConstants.GAME_WIDTH - 100, GameConstants_1.GameConstants.GAME_HEIGHT - 120, "60", { font: "25px Arial", fill: "#ffff00" });
            _this.add(_this.fpsLabel);
        }
        var timerBack = new Phaser.Image(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_1", "timer");
        timerBack.anchor.x = .5;
        topContainer.add(timerBack);
        var pontsBack = new Phaser.Image(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, 120, "texture_atlas_1", "points_moves_bar");
        pontsBack.anchor.x = .5;
        topContainer.add(pontsBack);
        _this.timeLabel = new Phaser.Text(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2 + 15, 20, " 05:00 ", { font: "70px Futura", fill: "#ffffff" });
        _this.timeLabel.anchor.set(.5, 0);
        _this.timeLabel.alpha = .9;
        topContainer.add(_this.timeLabel);
        _this.pointsLabel = new Phaser.Text(_this.game, 150, 133, "POINTS: 0 ", { font: "35px Futura", fill: "#ffffff" });
        _this.pointsLabel.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        topContainer.add(_this.pointsLabel);
        var grd = _this.pointsLabel.context.createLinearGradient(0, 0, 0, _this.pointsLabel.height);
        //  Add in 2 color stops
        grd.addColorStop(0, "#ffff00");
        grd.addColorStop(1, "#ffc509");
        //  And apply to the Text
        _this.pointsLabel.fill = grd;
        _this.movesLabel = new Phaser.Text(_this.game, 450, 133, "MOVES: 0 ", { font: "35px Futura", fill: "#ffffff" });
        _this.movesLabel.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        topContainer.add(_this.movesLabel);
        return _this;
    }
    HUD.prototype.startGame = function () {
        //
    };
    HUD.prototype.update = function () {
        _super.prototype.update.call(this);
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            this.fpsLabel.text = "fps: " + this.game.time.fps;
        }
        var m = Math.floor(GameVars_1.GameVars.time / 60);
        var s = GameVars_1.GameVars.time % 60;
        this.timeLabel.text = ("0" + m).slice(-2) + ":" + ("0" + s).slice(-2) + " ";
    };
    HUD.prototype.updateMoves = function () {
        this.movesLabel.setText("MOVES: " + GameVars_1.GameVars.moves + " ");
    };
    HUD.prototype.updatePoints = function () {
        this.pointsLabel.setText("POINTS: " + GameVars_1.GameVars.points + " ");
        if (this.tempScore != GameVars_1.GameVars.points) {
            this.tempScore = GameVars_1.GameVars.points;
            gamezop.setState({
                state: "playing",
                score: GameVars_1.GameVars.points,
                metadata: oMetaManager.meta
            });
            gamezop.showAd({ type: "midroll-ad" }, function (e) { return console.log(e); });
        }
    };
    return HUD;
}(Phaser.Group));
exports.HUD = HUD;
